import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';

export const useNewPdDesignEnabled = () => {
  const { newPdDesign } = useFeatureFlags();
  return newPdDesign;
};
